export const FATCH_LIVE_CASINO_GAMES = 'FATCH_LIVE_CASINO_GAMES';
export const SET_SEARCH_GAME = 'SET_SEARCH_GAME';
export const HANDLE_SEARCH_GAME = 'HANDLE_SEARCH_GAME';
